export const DEBOUNCE_TIME = 1200;
export const DEBOUNCE_CHAR_LENGTH = 3000;
